import React from 'react'
import PropTypes from 'prop-types'
import Elements from '../../containers/Elements'

const Sheet = () => (
  <div className="sheet">
        <Elements/>
      </div>
)
export default Sheet


// WEBPACK FOOTER //
// ./src/components/Sheet/index.js